export function getImageDimensions(
  file: File
): Promise<{ width: number | null; height: number | null }> {
  return new Promise((resolve, reject) => {
    // For now we only add the width/height for images
    if (!file.type.startsWith('image')) {
      resolve({ width: null, height: null })

      return
    }

    const img = new Image()

    img.onload = () => {
      resolve({
        width: img.naturalWidth,
        height: img.naturalHeight
      })

      URL.revokeObjectURL(img.src)
    }

    img.onerror = reject

    img.src = URL.createObjectURL(file)
  })
}
